// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; // Import Footer component
import DistrictMissionBody from '../../components/internal/AboutUs/DistrictMission/DistrictMissionBody'; // Import OurMissionBody component


function OurMission() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <DistrictMissionBody />
      <Footer />
    </>
  );
}

export default OurMission;